/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from '@vlinder-web/plugin-agent-service-react';

import {
  StaticContentPlugin,
  IStaticContentPluginMethods,
  LoadingContentPlugin,
  ILoadingContentPluginMethods,
  ErrorContentPlugin,
  IErrorContentPluginMethods,
  IProductPageDataMethods,
  ProductPageDataService,
  IHeaderNavContentMethods,
  HeaderNavContentService,
} from './plugins';

export type TAgent = IStaticContentPluginMethods &
  ILoadingContentPluginMethods &
  IErrorContentPluginMethods &
  IProductPageDataMethods &
  IHeaderNavContentMethods;

const getPlugins = () => {
  return [
    new StaticContentPlugin(),
    new ErrorContentPlugin(),
    new LoadingContentPlugin(),
    new ProductPageDataService(),
    new HeaderNavContentService(),
  ];
};

export const getAgent = () => {
  return createAgent<TAgent>({
    plugins: getPlugins(),
  });
};
